module.exports = __webpack_public_path__ + "static/media/logo.dcdc9c67.png";